<template>
  <car-form :lob="AE.code" />
</template>

<script>
import carForm from '@/components/Cargo/CarForm/carForm'
import {
  AE
} from '@/class/cargo/model/parameters/SystemConstants'
export default {
  name: 'CarFormAE',
  components: { carForm },
  data() {
    return {
      AE
    }
  }
}
</script>

<style scoped>

</style>
